/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { EtrangerDto } from '../models/etranger-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des étrangers
 */
@Injectable({
  providedIn: 'root',
})
export class EtrangersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation etrangerGetList
   */
  static readonly EtrangerGetListPath = '/api/etrangers/list';

  /**
   * Renvoie la liste des étrangers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<EtrangerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EtrangerDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des étrangers.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerGetList(params?: {
  }): Observable<Array<EtrangerDto>> {

    return this.etrangerGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EtrangerDto>>) => r.body as Array<EtrangerDto>)
    );
  }

  /**
   * Path part for operation etrangerLoadList
   */
  static readonly EtrangerLoadListPath = '/api/etrangers/load-list';

  /**
   * Renvoie la liste des étrangers (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des étrangers (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.etrangerLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation etrangerGenerateEtrangerCodes
   */
  static readonly EtrangerGenerateEtrangerCodesPath = '/api/etrangers/{etrangerId}/qrCode';

  /**
   * Crée un nouveau code barres et un QR code pour un étranger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerGenerateEtrangerCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerGenerateEtrangerCodes$Response(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;
  }): Observable<StrictHttpResponse<EtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerGenerateEtrangerCodesPath, 'post');
    if (params) {
      rb.path('etrangerId', params.etrangerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtrangerDto>;
      })
    );
  }

  /**
   * Crée un nouveau code barres et un QR code pour un étranger.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerGenerateEtrangerCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerGenerateEtrangerCodes(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;
  }): Observable<EtrangerDto> {

    return this.etrangerGenerateEtrangerCodes$Response(params).pipe(
      map((r: StrictHttpResponse<EtrangerDto>) => r.body as EtrangerDto)
    );
  }

  /**
   * Path part for operation etrangerGet
   */
  static readonly EtrangerGetPath = '/api/etrangers/{id}';

  /**
   * Renvoie l'étranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerGet$Response(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    id: number;
  }): Observable<StrictHttpResponse<EtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtrangerDto>;
      })
    );
  }

  /**
   * Renvoie l'étranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerGet(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    id: number;
  }): Observable<EtrangerDto> {

    return this.etrangerGet$Response(params).pipe(
      map((r: StrictHttpResponse<EtrangerDto>) => r.body as EtrangerDto)
    );
  }

  /**
   * Path part for operation etrangerPut
   */
  static readonly EtrangerPutPath = '/api/etrangers/{id}';

  /**
   * Met à jour l'étranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerPut$Response(params: {

    /**
     * Identifiant de l&#x27;étranger à mettre à jour
     */
    id: number;

    /**
     * Etranger
     */
    body: EtrangerDto
  }): Observable<StrictHttpResponse<EtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtrangerDto>;
      })
    );
  }

  /**
   * Met à jour l'étranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerPut(params: {

    /**
     * Identifiant de l&#x27;étranger à mettre à jour
     */
    id: number;

    /**
     * Etranger
     */
    body: EtrangerDto
  }): Observable<EtrangerDto> {

    return this.etrangerPut$Response(params).pipe(
      map((r: StrictHttpResponse<EtrangerDto>) => r.body as EtrangerDto)
    );
  }

  /**
   * Path part for operation etrangerDelete
   */
  static readonly EtrangerDeletePath = '/api/etrangers/{id}';

  /**
   * Supprime l'étranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerDelete$Response(params: {

    /**
     * Identifiant de l&#x27;étranger à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'étranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerDelete(params: {

    /**
     * Identifiant de l&#x27;étranger à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.etrangerDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation etrangerIsAlreadyExist
   */
  static readonly EtrangerIsAlreadyExistPath = '/api/etrangers/isAlreadyExist';

  /**
   * Recherche des étrangers par leur nom / prénom / date de naissance (case-insensitive).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerIsAlreadyExist()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerIsAlreadyExist$Response(params?: {

    /**
     * Nom recherché
     */
    firstName?: string;

    /**
     * Prénom recherché
     */
    lastname?: string;

    /**
     * Date de naissance recherchée
     */
    birthday?: string;
  }): Observable<StrictHttpResponse<EtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerIsAlreadyExistPath, 'get');
    if (params) {
      rb.query('firstName', params.firstName, {});
      rb.query('lastname', params.lastname, {});
      rb.query('birthday', params.birthday, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtrangerDto>;
      })
    );
  }

  /**
   * Recherche des étrangers par leur nom / prénom / date de naissance (case-insensitive).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerIsAlreadyExist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  etrangerIsAlreadyExist(params?: {

    /**
     * Nom recherché
     */
    firstName?: string;

    /**
     * Prénom recherché
     */
    lastname?: string;

    /**
     * Date de naissance recherchée
     */
    birthday?: string;
  }): Observable<EtrangerDto> {

    return this.etrangerIsAlreadyExist$Response(params).pipe(
      map((r: StrictHttpResponse<EtrangerDto>) => r.body as EtrangerDto)
    );
  }

  /**
   * Path part for operation etrangerPost
   */
  static readonly EtrangerPostPath = '/api/etrangers';

  /**
   * Crée l'étranger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerPost$Response(params: {

    /**
     * Etranger
     */
    body: EtrangerDto
  }): Observable<StrictHttpResponse<EtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtrangerDto>;
      })
    );
  }

  /**
   * Crée l'étranger.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerPost(params: {

    /**
     * Etranger
     */
    body: EtrangerDto
  }): Observable<EtrangerDto> {

    return this.etrangerPost$Response(params).pipe(
      map((r: StrictHttpResponse<EtrangerDto>) => r.body as EtrangerDto)
    );
  }

  /**
   * Path part for operation etrangerSetExclu
   */
  static readonly EtrangerSetExcluPath = '/api/etrangers/{id}/exclu';

  /**
   * Change le paramètre EstExclu d'un Etranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerSetExclu()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerSetExclu$Response(params: {

    /**
     * Identifiant de l&#x27;Etranger
     */
    id: number;

    /**
     * Paramètres d'exclusion
     */
    body: boolean
  }): Observable<StrictHttpResponse<EtrangerDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerSetExcluPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtrangerDto>;
      })
    );
  }

  /**
   * Change le paramètre EstExclu d'un Etranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerSetExclu$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerSetExclu(params: {

    /**
     * Identifiant de l&#x27;Etranger
     */
    id: number;

    /**
     * Paramètres d'exclusion
     */
    body: boolean
  }): Observable<EtrangerDto> {

    return this.etrangerSetExclu$Response(params).pipe(
      map((r: StrictHttpResponse<EtrangerDto>) => r.body as EtrangerDto)
    );
  }

  /**
   * Path part for operation etrangerDesactivate
   */
  static readonly EtrangerDesactivatePath = '/api/etrangers/{id}/desactivate';

  /**
   * Désactive l'étranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etrangerDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerDesactivate$Response(params: {

    /**
     * Identifiant de l&#x27;étranger à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: EtrangerDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, EtrangersService.EtrangerDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive l'étranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etrangerDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etrangerDesactivate(params: {

    /**
     * Identifiant de l&#x27;étranger à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: EtrangerDto
  }): Observable<number> {

    return this.etrangerDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
